(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["event-card"] && !Shopify.designMode) return;
  try {
    (function () {
      var resizeTimer = 0;

      /**
       * @param {ParentNode} [root]
       */
      function syncEventCardReadMores(root) {
        var scope = root || document;
        var cards = scope.querySelectorAll('.event-card--body-clamp');

        cards.forEach(function (card) {
          var btn = card.querySelector('[data-event-card-read-more]');
          if (!btn) return;

          if (card.classList.contains('event-card--expanded')) {
            btn.hidden = true;
            return;
          }

          var bodyId = btn.getAttribute('aria-controls');
          var body = bodyId ? document.getElementById(bodyId) : null;
          if (!body) {
            btn.hidden = true;
            return;
          }

          // Only show when line-clamp is actually truncating content.
          btn.hidden = !(body.scrollHeight > body.clientHeight + 1);
        });
      }

      function scheduleSync() {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          syncEventCardReadMores();
        }, 100);
      }

      document.addEventListener(
        'click',
        function (event) {
          var target = /** @type {HTMLElement | null} */ (event.target);
          var btn = target && target.closest ? target.closest('[data-event-card-read-more]') : null;
          if (!btn) return;

          var card = btn.closest('.event-card');
          var bodyId = btn.getAttribute('aria-controls');
          var body = bodyId ? document.getElementById(bodyId) : null;
          if (!card || !body) return;

          card.classList.add('event-card--expanded');
          btn.hidden = true;
          btn.setAttribute('aria-expanded', 'true');
        },
        { capture: false }
      );

      function init() {
        syncEventCardReadMores();
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () {
            syncEventCardReadMores();
          });
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }

      window.addEventListener('resize', scheduleSync);

      document.addEventListener('shopify:section:load', function (event) {
        syncEventCardReadMores(event.target);
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
